import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { InputText } from 'primereact/inputtext';
import { classNames } from 'primereact/utils';

import LabelName from 'components/UI/LabelName/LabelName';
import SubText from '../FormComponenets/SubText';
import { RequiredValidation } from 'components/UI/RequiredValidation/RequiredValidation';

export default function Name({ handleSettingsClick, item, isFormBuilder, relationFieldName, isRelation = false, isFromPreview = false }) {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const { subtext, first_name_show, middle_name_show, last_name_show } = item || {};

  return (
    <div className="w-100">
      <LabelName>Name</LabelName>
      <div className="d-flex gap-3">
        {first_name_show && (
          <div className="d-flex align-items-center w-100 flex-wrap">
            <Controller
              name={isRelation ? `${relationFieldName}first_name` : 'contact_data.first_name'}
              control={control}
              rules={
                isFormBuilder
                  ? {}
                  : {
                      required: 'First Name is required.',
                      pattern: {
                        value: /^[aA-zZ\s'-]+$/,
                        message: 'Only alphabets are allowed',
                      },
                    }
              }
              render={({ field, fieldState }) => (
                <InputText
                  type="text"
                  placeholder="Type in"
                  id={field.name}
                  value={field.value || ''}
                  className={classNames({ 'p-invalid': fieldState.invalid, 'w-100 input-shadow': true })}
                  style={{ pointerEvents: isFormBuilder || isFromPreview ? 'none' : 'auto' }}
                  onChange={(e) => field.onChange(e.target.value)}
                />
              )}
            />
            <div className="help-text-label w-100">
              First Name
              <span className="danger-text"> *</span>
            </div>
            <RequiredValidation field={isRelation ? `${relationFieldName}first_name` : 'contact_data.first_name'} errors={errors} />
          </div>
        )}
        {middle_name_show && (
          <div className="d-flex align-items-center w-100 flex-wrap">
            <Controller
              name={isRelation ? `${relationFieldName}middle_name` : 'contact_data.middle_name'}
              control={control}
              rules={
                isFormBuilder
                  ? {}
                  : {
                      pattern: {
                        value: /^[aA-zZ\s'-]+$/,
                        message: 'Only alphabets are allowed',
                      },
                    }
              }
              render={({ field }) => (
                <InputText
                  type="text"
                  style={{ pointerEvents: isFormBuilder || isFromPreview ? 'none' : 'auto' }}
                  placeholder="Type in"
                  id={field.name}
                  value={field.value || ''}
                  className="w-100 input-shadow"
                  onChange={(e) => field.onChange(e.target.value)}
                />
              )}
            />
            <div className="help-text-label">Middle Name</div>
            <RequiredValidation field={isRelation ? `${relationFieldName}middle_name` : 'contact_data.middle_name'} errors={errors} />
          </div>
        )}
        {last_name_show && (
          <div className="d-flex align-items-center w-100 flex-wrap">
            <Controller
              name={isRelation ? `${relationFieldName}last_name` : 'contact_data.last_name'}
              control={control}
              rules={
                isFormBuilder
                  ? {}
                  : {
                      required: 'Last Name is required.',
                      pattern: {
                        value: /^[aA-zZ\s'-]+$/,
                        message: 'Only alphabets are allowed',
                      },
                    }
              }
              render={({ field, fieldState }) => (
                <InputText
                  type="text"
                  placeholder="Type in"
                  id={field.name}
                  value={field.value || ''}
                  className={classNames({ 'p-invalid': fieldState.invalid, 'w-100 input-shadow': true })}
                  style={{ pointerEvents: isFormBuilder || isFromPreview ? 'none' : 'auto' }}
                  onChange={(e) => field.onChange(e.target.value)}
                  ref={isFormBuilder ? null : field.ref}
                />
              )}
            />
            <div className="help-text-label w-100">
              Last Name
              <span className="danger-text"> *</span>
            </div>
            <RequiredValidation field={isRelation ? `${relationFieldName}last_name` : 'contact_data.last_name'} errors={errors} />
          </div>
        )}
      </div>
      <SubText {...{ subtext, handleSettingsClick, item, isFormBuilder }} />
    </div>
  );
}
